/* eslint-disable no-unexpected-multiline */
/* eslint-disable no-unused-vars */

const install = Vue =>
{
  // Vue.prototype.$firebase = firebase;
};

export const plugin = { install };